"use strict";

var Traderdec = function () {

  var get_gtip_measures = function(edit_scope=false) {
    var gtip_id = $('#good_gtip_id').val();
    if (gtip_id !== '' && gtip_id !== null) {
      var export_country_id = $('#good_export_country_id').val();
      var import_country_id = $('#good_import_country_id').val();
      var export_import     =  $('#good_export_import').val();
      var us_gom_detail1 = document.getElementById("gom_1");
      var us_gom_detail2 = document.getElementById("gom_2");
      var us_gom_detail11 = document.getElementById("gom_11");
      var us_gom_detail22 = document.getElementById("gom_22");
      if (export_country_id == 'US') {
        us_gom_detail1.style.display = 'none';
        us_gom_detail2.style.display = 'none';
        us_gom_detail11.style.display = 'none';
        us_gom_detail22.style.display = 'none';
      }
      var supplementary_unit_added = false;
      var net_wg_added = false;
      var quota_desc_added = false;
      var hs_have_duty = false;
      var vat_value = '';
      var duty_value = '';
      var vat_duty_values = '';
      var duty_rate = 100;
      var vat_rate = 100;
      var additional_duty_value = '';
      $('#duty_vat_info').html('');
      $('#supplementary_unit_hint').remove();
      $('#net_wg_hint').remove();
      $('#good_supplementary_unit').removeClass("is-invalid");
      $('#quota_desc_hint').remove();
      $('#good_quota_desc').removeClass("is-invalid");
      // if(!edit_scope) {
      //   $('#good_preference_request').val('300').trigger('change');
      // }
      $.ajax({
        type: "GET",
        url: "/gtips/" + gtip_id + "/measures?export_import="+ export_import + "&export_country_id="+ export_country_id + "&import_country_id=" + import_country_id,
        dataType: "JSON",
        success: function(data) {
          if (data != null) {
            var measures_arr = data
            if (Array.isArray(measures_arr) && measures_arr.length) {
              for (var i = 0; i < measures_arr.length; i++) {

                var measure_data = measures_arr[i];
                var measure_code = measure_data["measure_type_id"];
                if (export_country_id == 'US') {
                  if (measure_code == '-1') {
                    var splittedArray = measure_data["duty_base"].split(",");
                    for (var i = 0; i < splittedArray.length; i++) {
                      if (i == 0) {
                        us_gom_detail1.style.display = 'initial';
                        us_gom_detail11.style.display = 'initial';
                       var measure_data1 = splittedArray[i];
                       if (!net_wg_added) {
                        if ($('#net_wg_hint').length) {
                          $('#net_wg_hint').html(measure_data1);
                        } else {
                          $('#good_net_wg').after('<p id="net_wg_hint" class="help-block text-danger">'+ measure_data1 +'</p>');
                        }
                        net_wg_added = true;
                      }
                      }
                      if (i == 1) {
                        us_gom_detail2.style.display = 'initial';
                        us_gom_detail22.style.display = 'initial';
                        var measure_data2 = splittedArray[i];
                        if (!supplementary_unit_added) {
                          if ($('#supplementary_unit_hint').length) {
                            $('#supplementary_unit_hint').html(measure_data2);
                          } else {
                            $('#good_supplementary_unit').after('<p id="supplementary_unit_hint" class="help-block text-danger">'+ measure_data2 +'</p>');
                          }
                          supplementary_unit_added = true;
                        }
                      }
                    }
                  }
                } else {
                  if ((measure_code == '109') || (measure_code == '110')) {
                    if (!supplementary_unit_added) {
                      if ($('#supplementary_unit_hint').length) {
                        $('#supplementary_unit_hint').html(measure_data["duty_base"]);
                      } else {
                        $('#good_supplementary_unit').after('<p id="supplementary_unit_hint" class="help-block text-danger">'+ measure_data["duty_base"] +'</p>');
                      }
                      $('#good_supplementary_unit').addClass("is-invalid");
                      supplementary_unit_added = true;
                    }
                  }
                }
                if (measure_data["duty_base"] != '' && measure_data["duty_base"] != null && measure_data["duty_base"] != 'p/st') {

                  if ((measure_code == '142') || (measure_code == '103')) {
                    if (parseFloat(measure_data["duty_base"]) < duty_rate){
                      duty_rate = parseFloat(measure_data["duty_base"]);
                      duty_value = measure_data["measure_type_desc"] + ': ' + measure_data["duty_base"] + ' (' + measure_data["geo_area_desc"] + ')';
                      duty_value = duty_value.replaceAll("ERGA OMNES","All Countries");
                    }
                  } else if ((measure_code == '305')){
                    if (parseFloat(measure_data["duty_base"]) < vat_rate){
                      vat_rate = parseFloat(measure_data["duty_base"]);
                      vat_value = 'VAT: ' + measure_data["duty_base"];
                    }
                  } else if ((measure_code == '695') || (measure_code == '696')){
                    additional_duty_value = measure_data["duty_base"];
                  }
                  if ((vat_value != '') && (duty_value != '')){
                    vat_duty_values = vat_value + ' - ' + duty_value
                  } else if ((vat_value == '') && (duty_value != '')) {
                    vat_duty_values = duty_value
                  } else if ((vat_value != '') && (duty_value == '')) {
                    vat_duty_values = vat_value
                  }
                  if (vat_duty_values != '') {
                    $('#duty_vat_info').html(vat_duty_values);
                  }
                }

                // if(!edit_scope) {
                //   if(duty_rate != 0){
                //     $('#good_preference_request').val('100').trigger('change');
                //   } else if (duty_rate == 0 && duty_rate == 100) {
                //     $('#good_preference_request').val('300').trigger('change');
                //   }
                // }

                if (measure_data["additional_code"] != '' && measure_data["additional_code"] != null) {
                  if (!quota_desc_added) {
                    if ($('#quota_desc_hint').length) {
                      $('#quota_desc_hint').html(measure_data["additional_code"]);
                    } else {
                      $('#good_quota_desc').after('<p id="quota_desc_hint" class="help-block text-danger">'+ measure_data["additional_code"] +'</p>');
                    }
                    $('#good_quota_desc').addClass("is-invalid");
                    quota_desc_added = true;
                  }
                }
              }
            }
          }
        }
      });
      $('#gtip_measures_link').show();
    } else {
      $('#duty_vat_info').html('');
      $('#gtip_measures_link').hide();
    }
  }

  var show_gtip_measures = function() {
    var gtip_id = $('#good_gtip_id').val();
    if (gtip_id !== '' && gtip_id !== null) {
      var export_country_id = $('#good_export_country_id').val();
      var import_country_id = $('#good_import_country_id').val();
      var export_import     =  $('#good_export_import').val();
      $.ajax({
        type: "GET",
        url: "/gtips/" + gtip_id + "/measures?export_import="+ export_import + "&export_country_id="+ export_country_id + "&import_country_id=" + import_country_id,
        dataType: "script",
      });
    }
  }

  var find_eori_for_ducr = function() {
    var ducr_eori = '';
    var traderdec_doc_type = $('#traderdec_doc_type').val();
    if ($('#traderdec_ducr_from').val() == 'S') {
      if (traderdec_doc_type == 'import') {
        ducr_eori = $('#traderdec_consignee_eori').val();
      } else {
        ducr_eori = $('#traderdec_consignor_eori').val();
      }
    }
    if (ducr_eori === '') {
      ducr_eori = $('#traderdec_declarant_eori').val();
    }
    return ducr_eori;
  }

  var set_ducr = function() {
    var current_year = new Date().getFullYear();
    var ducr_eori = find_eori_for_ducr();
    if (typeof ducr_eori !== typeof undefined && ducr_eori !== null) {
      var comm_ref  = $('#traderdec_commercial_ref').val();
      var new_ducr  = current_year.toString().slice(-1) + ducr_eori + '-' + comm_ref
      $('#traderdec_ducr').val(new_ducr);
    }
  }

  var set_previous_data = function() {
    var declaration_type = $('#traderdec_declaration_type').val();
    if (typeof declaration_type !== typeof undefined && declaration_type !== null && (declaration_type.includes("IMZ") || declaration_type.includes("IMY"))) {
      $('#previous_data_div').show();

    } else {
      $('#previous_data_div').hide();
    }
  }

  var set_consignor_view = function () {
    if ($('#traderdec_multiple_consignor').prop('checked')) {
      $('#traderdec_consignor_id').attr('disabled', true);
    } else {
      $('#traderdec_consignor_id').attr('disabled', false);
    }
  }

  var set_consignee_view = function () {
    if ($('#traderdec_multiple_consignee').prop('checked')) {
      $('#traderdec_consignee_id').attr('disabled', true);
    } else {
      $('#traderdec_consignee_id').attr('disabled', false);
    }
  }

  var set_export_country = function () {
    if (($('#traderdec_export_country_id').val() === '') && ($('#traderdec_consignor_country_id').val() !== '')) {
      $('#traderdec_export_country_id').val($('#traderdec_consignor_country_id').val());
      $('#traderdec_export_country_id').trigger('change');
    }
  }

  var set_import_country = function () {
    if (($('#traderdec_import_country_id').val() === '') && ($('#traderdec_consignee_country_id').val() !== '')) {
      $('#traderdec_import_country_id').val($('#traderdec_consignee_country_id').val());
      $('#traderdec_import_country_id').trigger('change');
    }
  }

  return {
    init: function () {

      if (edit_scope == false){
        set_ducr();
      };

      $(document).on("change", "#traderdec_consignor_eori", function() {
        set_ducr();
      });
      $(document).on("change", "#traderdec_consignee_eori", function() {
        set_ducr();
      });
      $(document).on("change", "#traderdec_ducr_from", function() {
        set_ducr();
      });
      $(document).on("change", "#traderdec_declarant_eori", function() {
        set_ducr();
      });
      $(document).on("change", "#traderdec_commercial_ref", function() {
        set_ducr();
      });

      $(document).on("change", "#traderdec_multiple_consignor", function () {
        set_consignor_view();
      });
      $(document).on("change", "#traderdec_multiple_consignee", function() {
        set_consignee_view();
      });
      $(document).on("change", "#traderdec_declaration_type", function() {
        set_previous_data();
      });
    },
    get_gtip_measures: function (edit_scope){
      get_gtip_measures(edit_scope);
    },
    show_gtip_measures: function() {
      show_gtip_measures();
    },
    set_export_country: function (){
      set_export_country();
    },
    set_import_country: function (){
      set_import_country();
    },
    set_ducr: function (){
      set_ducr();
    },
    set_previous_data: function (){
      set_previous_data();
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Traderdec;
}
